import { type MouseEventHandler } from 'react';
import ChevronL from 'assets/icons/chevron-l.svg';
import ChevronR from 'assets/icons/chevron-r.svg';
import styles from './pagination.module.scss';

function Pagination({ onClick, backButton, forwardButton }: Params) {
	return (
		<div className={styles.wrapper}>
			{!backButton.hidden && backButton?.value && (
				<button
					title={backButton.name || backButton.value}
					className={`${styles.button} ${styles.backButton}`}
					onClick={onClick}
					value={backButton.value}
					disabled={backButton.disabled}
				>
					<ChevronL />
					{backButton.name || backButton.value}
				</button>
			)}
			{!forwardButton.hidden && forwardButton?.value && (
				<button
					title={forwardButton.name || forwardButton.value}
					className={`${styles.button} ${styles.forwardButton} `}
					onClick={onClick}
					value={forwardButton.value}
					disabled={forwardButton.disabled}
				>
					{forwardButton.name || forwardButton.value}
					<ChevronR />
				</button>
			)}
		</div>
	);
}

type PaginationButton = {
	name: string;
	value?: any;
	disabled?: boolean;
	hidden?: boolean;
};

type Params = {
	onClick: MouseEventHandler<HTMLButtonElement>;
	backButton: PaginationButton;
	forwardButton: PaginationButton;
};

export default Pagination;
